import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import type { Submission } from '../submission.js';
import { getSubmissionsByExamIdQuery } from './get-submissions.js';

// Build recursive selection for submission tasks with nested subTasksSubmission
const buildTaskSubmissionSelection = (depth: number): any => {
  const baseSelection: any = {
    _id: 1,
    taskNumber: 1,
    gradingState: 1,
    imageIds: 1,
    studentAnswer: 1,
    gradingResult: {
      score: 1,
      explanation: 1,
      confidence: 1,
      reviewerFeedback: 1,
      actualPointsGiven: 1,
      isApproved: 1,
    },
    boundingBoxes: {
      _id: 1,
      pageNumber: 1,
      imageId: 1,
      ocrExtractedText: 1,
      contentType: 1,
      confidence: 1,
      approved: 1,
      ocrRerunning: 1,
      topLeft: { x: 1, y: 1 },
      bottomRight: { x: 1, y: 1 },
    },
    grammarEvaluation: {
      status: 1,
      errorCount: 1,
      wordCount: 1,
      fehlerindex: 1,
      languageCode: 1,
      errors: {
        _id: 1,
        offset: 1,
        length: 1,
        message: 1,
        shortMessage: 1,
        ruleId: 1,
        category: 1,
        context: 1,
        boundingBox: {
          pageNumber: 1,
          imageId: 1,
          topLeft: { x: 1, y: 1 },
          bottomRight: { x: 1, y: 1 },
        },
      },
    },
    overallGradingResult: {
      score: 1,
      explanation: 1,
      confidence: 1,
      reviewerFeedback: 1,
      actualPointsGiven: 1,
      isApproved: 1,
    },
  };

  if (depth > 0) {
    baseSelection.subTasksSubmission = buildTaskSubmissionSelection(depth - 1);
  }

  return baseSelection;
};

const fullSubmissionSelection: BaseQLSelectionSet<Submission> = {
  _id: 1,
  examId: 1,
  studentName: 1,
  studentId: 1,
  imageIds: 1,
  submittedAt: 1,
  state: 1,
  splitConfirmed: 1,
  answersSubmittedOnline: 1,
  splitEvaluationResult: {
    confidence: 1,
    issues: 1,
  },
  grammarGradingSummary: {
    errorCount: 1,
    wordCount: 1,
    fehlerindex: 1,
    fiApplied: 1,
    deductionSteps: 1,
    baseGrade: 1,
    adjustedGrade: 1,
    computedAt: 1,
  },
  languageUseRuleResults: {
    _id: 1,
    languageUseSchemeId: 1,
    score: 1,
    explanation: 1,
    confidence: 1,
    reviewerFeedback: 1,
    isApproved: 1,
    actualPointsGiven: 1,
    computedAt: 1,
  },
  taskSubmissions: buildTaskSubmissionSelection(5),
};

export const getExamSubmissions = (examId: string) => getSubmissionsByExamIdQuery(examId)(fullSubmissionSelection);
